import { FormComponent } from "../../../utils/enums";

export const addSupplierFormSchema = {
  name: "addSupplierForm",
  type: "form",
  target: "submit",
  title: "Add New Supplier",
  properties: {
    name: {
      label: "Supplier Name",
      type: "text",
      required: true,
      component: FormComponent.Input,
      componentProps: {
        placeholder: "e.g., Pharma International",
      },
    },
    contactPerson: {
      label: "Contact Person",
      type: "text",
      required: false,
      component: FormComponent.Input,
      componentProps: {
        placeholder: "e.g., Mr. Jean El-Khoury",
      },
    },
    phone: {
      label: "Phone Number",
      type: "text",
      required: true,
      component: FormComponent.Input,
      componentProps: {
        placeholder: "e.g., +961 1 234 567",
      },
    },
    email: {
      label: "Email Address",
      type: "email",
      required: false,
      component: FormComponent.Input,
      componentProps: {
        placeholder: "e.g., orders@pharma.com",
        type: "email",
      },
    },
    address: {
      label: "Address",
      type: "textarea",
      required: false,
      component: FormComponent.Textarea,
      componentProps: {
        placeholder: "Enter full address",
        rows: 3,
      },
    },
  },
}; 